import {Component, OnInit} from '@angular/core';
import {LandingPageTile} from '../../shared/tiles/home-tile.model';
import {LandingPageService} from '../landing-page.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LandingPageConfig} from './landing-config.model';
import {ServiceAnswer} from '../../shared/service-answer';
import {MessageService} from '../../shared/message.service';
import {BaseComponent} from '../../components/general/base/base.component';

@Component({
  selector: 'qm-landing-controller',
  templateUrl: './landing-controller.component.html',
  styleUrls: ['./landing-controller.component.scss']
})
export class LandingControllerComponent extends BaseComponent implements OnInit {

  public landingPageSetup: LandingPageConfig = new LandingPageConfig();
  public landingPages: Array<LandingPageConfig>;

  constructor(private landingPageService: LandingPageService,
              private modalService: NgbModal,
              private messagesService: MessageService) {
    super();
    this.name = 'LandingControllerComponent';
  }

  ngOnInit() {
    this.fetchEntities();
  }

  public getAvailableTiles(): Array<LandingPageTile> {
    return this.landingPageService.availableTiles.filter(o => {
      return o.availableOnLanding;
    });
  }

  public toggleTileVisible(item: LandingPageTile): void {
    this.landingPageService.toggleTileVisible(item);
  }

  public open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
  }

  public isTileVisible(tileId: string) {
    return this.landingPageService.isTileVisible(tileId);
  }

  public async saveSetup() {
    this.landingPageSetup.tiles = this.landingPageService.dashboard;
    console.log(this.landingPageSetup);
    const result = await this.landingPageService.create(this.landingPageSetup);
    console.log(result);
  }

  public loadSavedSetup(setup: LandingPageConfig) {
    // TODO This should perform some kind of validation in order to ensure that no deprecated setups are loaded
    this.landingPageService.dashboard = setup.tiles;
  }

  private async fetchEntities(): Promise<void> {
    try {
      const serviceAnswer: ServiceAnswer<LandingPageConfig[]> = await this.landingPageService.list();
      this.landingPages = serviceAnswer.data;
    } catch (error) {
      const message: string = 'Unexpected error when fetching entities:' + JSON.stringify(error);
      console.error(message);
      this.messagesService.addDanger(message);
    }
  }

  public revertToDefault() {
    this.landingPageService.revertToDefault();
  }
}
